import { Mail, Phone, MessageSquare, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import MarketingShell from "@/components/marketing/MarketingShell";
import { useSeo } from "@/lib/seo";
import { useContact, telHref } from "@/lib/contact";

export default function Contact() {
  useSeo({
    title: "Contact Us | Infant Sleep Consultant Near Me",
    description: "Contact Infant Sleep Consultant Near Me. Email is our main channel for enrollment, course and account questions; phone is available for scheduling and technical help.",
    canonical: "/contact",
  });
  const { email, phone } = useContact();

  return (
    <MarketingShell>
      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="eyebrow text-[#C2836B] mb-3">Contact & Support</div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#F7F5F0] leading-tight">Contact Us</h1>
        <p className="text-[#A39E98] mt-4 text-[17px] leading-relaxed max-w-2xl">
          Questions about admissions, courses, class schedules or your student account are welcome by email. Phone is available as a backup for anything time-sensitive.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mt-10">
          <a href={`mailto:${email}`} data-testid="contact-email" className="card-night rounded-2xl p-6 hover:border-[#C2836B]/40 transition-colors block">
            <Mail className="text-[#C2836B]" size={22} />
            <div className="eyebrow text-[#738075] mt-4 mb-1">Email — general support</div>
            <div className="text-[#F7F5F0] text-lg break-all">{email}</div>
            <div className="text-[#A39E98] text-sm mt-2">The main channel for admissions, course, tuition and account questions.</div>
          </a>
          <a href={telHref(phone)} data-testid="contact-phone" className="card-night rounded-2xl p-6 hover:border-[#C2836B]/40 transition-colors block">
            <Phone className="text-[#C2836B]" size={22} />
            <div className="eyebrow text-[#738075] mt-4 mb-1">Phone — backup for logistics</div>
            <div className="text-[#F7F5F0] text-lg">{phone}</div>
            <div className="text-[#A39E98] text-sm mt-2">For account access, class scheduling, technical issues, or time-sensitive logistics.</div>
          </a>
        </div>

        <div className="card-night rounded-2xl p-6 mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-[#C2836B] eyebrow mb-1"><MessageSquare size={14} /> Current students</div>
            <p className="text-[#A39E98] text-sm max-w-xl">Your student portal holds your courses, class schedule, sleep journal and progress. Private consulting clients also find their secure messaging thread there.</p>
          </div>
          <Link to="/portal" className="btn-clay px-5 py-2.5 rounded-full text-sm whitespace-nowrap inline-flex items-center gap-2">Go to the student portal <ArrowRight size={15} /></Link>
        </div>

        <p className="text-xs text-[#6b665e] mt-10 leading-relaxed max-w-2xl">
          Infant sleep education is not medical care. For medical or health concerns, please contact your pediatrician or emergency services.
        </p>
      </section>
    </MarketingShell>
  );
}
